import PaintBrushIcon from 'icons/task-draw.react.svg';

import {useContext} from 'react';
import classNames from 'classnames';

import _ from 'topmeteo/utils/i18n';

import {DrawingContext} from '../Drawing';

const StartLabel = _('Start Drawing');
const StopLabel = _('Stop Drawing');

const ToggleDrawButton = () => {
    const {isDrawing, startDrawing, finishDrawing} = useContext(DrawingContext);
    const onClick = isDrawing ? finishDrawing : startDrawing;
    const title = isDrawing ? StopLabel : StartLabel;
    const className = classNames('toggle-draw', {drawing: isDrawing});

    return (
        <button className={className} onClick={onClick} title={title}>
            <PaintBrushIcon />
        </button>
    );
};

export default ToggleDrawButton;
